module.exports = __webpack_public_path__ + "img/0Q3C6212_BlackMatted_MockedUp.05d36899.jpg";